/* eslint-disable no-restricted-globals */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-access-state-in-setstate */
/* eslint-disable react/no-unused-class-component-methods */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Alert, Row, Col, FormGroup, ControlLabel, FormControl, Checkbox, Button, } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import { titleize } from 'underscore.string';
import CustomersActionCreators from '../../../actions/CustomersActionCreators';
import DriverStore from '../../../stores/DriverStore';
import SessionStore from '../../../stores/SessionStore';
import ToastStore from '../../../stores/ToastStore';
import AssetsConfig from '../../../config/assets'; // only used for defaultPhotoFilename
import ChangePasswordModal from '../user/change-password-modal';
import { phoneRegex } from '../../../utils/validation-regex';
import { AvatarWithUpload } from '../user/AvatarWithUpload';
class DriverEditForm extends Component {
    constructor(props) {
        super(props);
        this.handleDismissAlert = () => {
            this.setState({
                notification: {},
                errors: {},
            });
        };
        this.populateForm = async () => {
            const driver = DriverStore.getDriver(this.props.match.params.id);
            if (!driver) {
                return;
            }
            const { _id, username, first_name, last_name, phone, picture, address = {}, receive_offers, } = driver;
            const { street = '', city = '', state = '', zipcode = '' } = address;
            this.setState({
                _id,
                username,
                first_name: first_name || '',
                last_name: last_name || '',
                phone: phone || '',
                picture,
                street,
                city,
                state,
                zipcode,
                receive_offers,
            });
        };
        this.handleUpdatePassword = (newPassword) => {
            CustomersActionCreators.updatePassword(this.props.match.params.id, newPassword);
        };
        this.handleStoreChange = () => {
            this.populateForm();
        };
        this.handleDriverUpdated = () => {
            const notification = ToastStore.getLatestNotification();
            this.setState({ notification });
        };
        this.handleSubmit = () => {
            const errors = this.validate();
            const isValid = Object.keys(errors).length === 0;
            if (isValid) {
                const { _id, first_name, last_name, username, phone, street, city, state, zipcode, receive_offers, } = this.state;
                const driver = {
                    _id,
                    carrier: SessionStore.getUser()._id,
                    name,
                    first_name,
                    last_name,
                    username,
                    phone,
                    address: {
                        street,
                        city,
                        state,
                        zipcode,
                    },
                    receive_offers,
                };
                CustomersActionCreators.updateDriver(driver);
            }
        };
        this.state = {
            username: '',
            first_name: '',
            last_name: '',
            phone: '',
            picture: AssetsConfig.defaultPhotoFilename,
            street: '',
            city: '',
            state: '',
            zipcode: '',
            receive_offers: false,
            errors: {},
            showChangePasswordModal: false,
            notification: {},
            successMessage: '',
            id: null,
        };
    }
    componentDidMount() {
        const id = this.props.match.params.id;
        ToastStore.addChangeListener(this.handleDriverUpdated);
        DriverStore.addChangeListener(this.handleStoreChange);
        if (id) {
            CustomersActionCreators.getDriver(id);
        }
    }
    componentWillUnmount() {
        ToastStore.removeChangeListener(this.handleDriverUpdated);
        DriverStore.removeChangeListener(this.handleStoreChange);
    }
    getHandleInputChange(field) {
        return (e) => {
            this.setState({
                [field]: e.target.value,
            });
        };
    }
    getHandleCheckboxChange(field) {
        return () => {
            this.setState({
                [field]: !this.state[field],
            });
        };
    }
    getValidationState(field) {
        if (Object.prototype.hasOwnProperty.call(this.state.errors, field)) {
            return 'error';
        }
        return null;
    }
    validate() {
        const errors = {};
        const { first_name, last_name, phone, username } = this.state;
        if (!first_name) {
            errors.first_name = 'FIRST_NAME_REQUIRED';
        }
        if (!last_name) {
            errors.last_name = 'LAST_NAME_REQUIRED';
        }
        if (!phone) {
            errors.phone = 'PHONE_REQUIRED';
        }
        else if (phone && !phoneRegex.test(phone)) {
            errors.phone = 'PHONE_NUMBER_NOT_VALID';
        }
        if (!username) {
            errors.username = 'USERNAME_NOT_VALID';
        }
        this.setState({
            errors,
            notification: {},
        });
        return errors;
    }
    renderErrors() {
        const { t } = this.props;
        if (Object.keys(this.state.errors).length > 0) {
            return (React.createElement(Alert, { bsStyle: "danger", onDismiss: this.handleDismissAlert },
                React.createElement("ul", null, Object.keys(this.state.errors).map((errorKey) => (React.createElement("li", { key: errorKey }, t(this.state.errors[errorKey])))))));
        }
        return null;
    }
    renderPhoto() {
        const driver = DriverStore.getDriver(this.props.match.params.id);
        return (React.createElement("div", { className: "dropdown-wrapper" },
            React.createElement(AvatarWithUpload, { key: this.props.match.params.id, userId: this.props.match.params.id, altName: this.state.name, style: {
                    borderWidth: 2,
                    borderColor: '#5cb85c',
                    borderStyle: 'dashed',
                    borderRadius: 5,
                    display: 'inline-block',
                    padding: 0,
                    textAlign: 'center',
                }, avatarClassName: "img-responsive img-thumbnail" })));
    }
    renderNotification() {
        const notification = this.state.notification || {};
        if (notification.title) {
            const level = notification.level === 'success' ? notification.level : 'danger';
            const { title, body } = notification;
            return (React.createElement(Alert, { bsStyle: level, onDismiss: this.handleDismissAlert },
                React.createElement("p", null, title),
                React.createElement("p", null, body)));
        }
        return null;
    }
    render() {
        const { t } = this.props;
        return (React.createElement("div", { className: "carrier-center" },
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement("h3", null, t('EDIT_DRIVER')))),
            React.createElement("form", null,
                React.createElement(Row, null,
                    React.createElement(Col, { md: 6 },
                        this.renderNotification(),
                        this.renderErrors(),
                        React.createElement(FormGroup, { controlId: "first_name", validationState: this.getValidationState('first_name') },
                            React.createElement(ControlLabel, null, t('FIRST_NAME')),
                            React.createElement(FormControl, { type: "text", value: this.state.first_name, placeholder: t('ENTER_FIRST_NAME'), onChange: this.getHandleInputChange('first_name') })),
                        React.createElement(FormGroup, { controlId: "last_name", validationState: this.getValidationState('last_name') },
                            React.createElement(ControlLabel, null, t('LAST_NAME')),
                            React.createElement(FormControl, { type: "text", value: this.state.last_name, placeholder: t('ENTER_LAST_NAME'), onChange: this.getHandleInputChange('last_name') })),
                        React.createElement(FormGroup, { controlId: "street", validationState: this.getValidationState('street') },
                            React.createElement(ControlLabel, null, titleize(t('STREET'))),
                            React.createElement(FormControl, { type: "text", value: this.state.street, placeholder: t('ENTER_STREET'), onChange: this.getHandleInputChange('street') })),
                        React.createElement(FormGroup, { controlId: "city", validationState: this.getValidationState('city') },
                            React.createElement(ControlLabel, null, titleize(t('CITY'))),
                            React.createElement(FormControl, { type: "text", value: this.state.city, placeholder: t('ENTER_CITY'), onChange: this.getHandleInputChange('city') })),
                        React.createElement(Row, null,
                            React.createElement(Col, { md: 6 },
                                React.createElement(FormGroup, { controlId: "state", validationState: this.getValidationState('state') },
                                    React.createElement(ControlLabel, null, titleize(t('STATE'))),
                                    React.createElement(FormControl, { type: "text", value: this.state.state, placeholder: t('ENTER_STATE'), onChange: this.getHandleInputChange('state') }))),
                            React.createElement(Col, { md: 6 },
                                React.createElement(FormGroup, { controlId: "zipcode", validationState: this.getValidationState('zipcode') },
                                    React.createElement(ControlLabel, null, titleize(t('ZIP_CODE'))),
                                    React.createElement(FormControl, { type: "text", value: this.state.zipcode, placeholder: t('ENTER_ZIP_CODE'), onChange: this.getHandleInputChange('zipcode') })))),
                        React.createElement(FormGroup, { controlId: "username", validationState: this.getValidationState('username') },
                            React.createElement(ControlLabel, null, t('USERNAME')),
                            React.createElement(FormControl, { type: "username", value: this.state.username, placeholder: t('ENTER_USERNAME'), onChange: this.getHandleInputChange('username') })),
                        React.createElement(FormGroup, { controlId: "phone", validationState: this.getValidationState('phone') },
                            React.createElement(ControlLabel, null, t('PHONE')),
                            React.createElement(FormControl, { type: "phone", value: this.state.phone, placeholder: t('ENTER_PHONE'), onChange: this.getHandleInputChange('phone') })),
                        React.createElement(Checkbox, { ref: (ref) => {
                                this.checkboxRef = ref;
                            }, checked: this.state.receive_offers, value: this.state.receive_offers, onChange: this.getHandleCheckboxChange('receive_offers') }, t('RECEIVE_OFFERS_QUESTION')),
                        React.createElement(FormGroup, null,
                            React.createElement(Button, { bsStyle: "primary", block: true, onClick: this.handleSubmit }, t('SAVE')))),
                    React.createElement(Col, { md: 3 },
                        this.renderPhoto(),
                        React.createElement("div", { style: { marginTop: '1em' } },
                            React.createElement(Button, { onClick: () => this.setState({ showChangePasswordModal: true }) }, t('CHANGE_PASSWORD'))),
                        React.createElement(ChangePasswordModal, { show: this.state.showChangePasswordModal, onHide: () => this.setState({ showChangePasswordModal: false }), onSave: this.handleUpdatePassword }))))));
    }
}
DriverEditForm.propTypes = {
    match: PropTypes.object.isRequired,
};
export default withTranslation()(DriverEditForm);
